module.exports = __webpack_public_path__ + "media/images/newsletter-default-fd16e8c1071467f9aec801c13ca09005.jpg";